/**
 * @packageDocumentation
 * @module StockChartShared
 */
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class StockChartFilterService {

  constructor() { }
}
